export const PACKAGE_SEARCHABLE_FIELDS = [
  "displayName",
  "packageName",
  "packageId",
];

export const getPackageLabel = (pkg) =>
  pkg.displayName || pkg.packageName || `Package ${pkg.packageId}`;
